var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SelectionWithMultimediaMixin, SelectionWithNoteSourceCitationMixin } from './mixin';
import { SelectionFamilyRecord, SelectionName, SelectionIndividualEventFamily, SelectionIndividualEventFamilyAdoption, SelectionIndividualEvent, SelectionIndividualAttribute, SelectionChildFamilyLink, SelectionSpouseFamilyLink, SelectionAssociation } from './internal';
import { SelectionRecord } from './base';
/**
 * An individual record.
 * <table>
 *  <tr><th>Pointer</th><td>Yes</td></tr>
 *  <tr><th>Value</th><td>No</td></tr>
 * </table>
 */
var SelectionIndividualRecord = /** @class */ (function (_super) {
    __extends(SelectionIndividualRecord, _super);
    function SelectionIndividualRecord() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectionIndividualRecord.prototype.getName = function () {
        return this.get("NAME" /* Name */, null, SelectionName);
    };
    SelectionIndividualRecord.prototype.getSex = function () {
        return this.get("SEX" /* Sex */);
    };
    SelectionIndividualRecord.prototype.getFamilyAsChild = function () {
        var _this = this;
        var children = [];
        var rootIndex = this.rootNode._index;
        if (rootIndex !== undefined && rootIndex.asChild !== undefined) {
            for (var i = 0; i < this.length; i++) {
                var node = this[i];
                if (node.pointer !== null) {
                    var familiesIdx = rootIndex.asChild[node.pointer];
                    if (familiesIdx !== undefined) { // TODO this shouldn't happen, is it necessary?
                        familiesIdx.forEach(function (familyIdx) {
                            children.push(_this.rootNode.children[familyIdx]);
                        });
                    }
                }
            }
        }
        else {
            // Pretty bad performance when the index is not available, but we don't have any other choice
            // Cost could be mitigated for large selections by using a hash set (but tricky due to multiplicity)
            var nodesFamily = this.rootNode.children.filter(function (nodeFamily) { return nodeFamily.tag === "FAM" /* Family */; });
            var _loop_1 = function (i) {
                var node = this_1[i];
                if (node.pointer !== null) {
                    nodesFamily.filter(function (nodeFamily) { return nodeFamily.children.some(function (nodeChild) { return nodeChild.tag === "CHIL" /* Child */ && nodeChild.value === node.pointer; }); })
                        .forEach(function (nodeFamily) { return children.push(nodeFamily); });
                }
            };
            var this_1 = this;
            for (var i = 0; i < this.length; i++) {
                _loop_1(i);
            }
        }
        return new SelectionFamilyRecord(this.rootNode, children);
    };
    SelectionIndividualRecord.prototype.getFamilyAsSpouse = function () {
        var _this = this;
        var children = [];
        var rootIndex = this.rootNode._index;
        if (rootIndex !== undefined && rootIndex.asSpouse !== undefined) {
            for (var i = 0; i < this.length; i++) {
                var node = this[i];
                if (node.pointer !== null) {
                    var familiesIdx = rootIndex.asSpouse[node.pointer];
                    if (familiesIdx !== undefined) { // ditto
                        familiesIdx.forEach(function (familyIdx) {
                            children.push(_this.rootNode.children[familyIdx]);
                        });
                    }
                }
            }
        }
        else {
            var nodesFamily = this.rootNode.children.filter(function (nodeFamily) { return nodeFamily.tag === "FAM" /* Family */; });
            var _loop_2 = function (i) {
                var node = this_2[i];
                if (node.pointer !== null) {
                    nodesFamily.filter(function (nodeFamily) { return nodeFamily.children.some(function (nodeChild) { return (nodeChild.tag === "HUSB" /* Husband */ || nodeChild.tag === "WIFE" /* Wife */) && nodeChild.value === node.pointer; }); })
                        .forEach(function (nodeFamily) { return children.push(nodeFamily); });
                }
            };
            var this_2 = this;
            for (var i = 0; i < this.length; i++) {
                _loop_2(i);
            }
        }
        return new SelectionFamilyRecord(this.rootNode, children);
    };
    /* Events */
    SelectionIndividualRecord.prototype.getEventBirth = function () {
        return this.get("BIRT" /* Birth */, null, SelectionIndividualEventFamily);
    };
    SelectionIndividualRecord.prototype.getEventChristening = function () {
        return this.get("CHR" /* Christening */, null, SelectionIndividualEventFamily);
    };
    SelectionIndividualRecord.prototype.getEventDeath = function () {
        return this.get("DEAT" /* Death */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventBurial = function () {
        return this.get("BURI" /* Burial */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventCremation = function () {
        return this.get("CREM" /* Cremation */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventAdoption = function () {
        return this.get("ADOP" /* Adoption */, null, SelectionIndividualEventFamilyAdoption);
    };
    SelectionIndividualRecord.prototype.getEventBaptism = function () {
        return this.get("BAPM" /* Baptism */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventBarMitzvah = function () {
        return this.get("BARM" /* BarMitzvah */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventBatMitzvah = function () {
        return this.get("BASM" /* BatMitzvah */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventAdultChristening = function () {
        return this.get("CHRA" /* AdultChristening */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventConfirmation = function () {
        return this.get("CONF" /* Confirmation */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventFirstCommunion = function () {
        return this.get("FCOM" /* FirstCommunion */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventNaturalization = function () {
        return this.get("NATU" /* Naturalization */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventEmigration = function () {
        return this.get("EMIG" /* Emigration */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventImmigration = function () {
        return this.get("IMMI" /* Immigration */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventCensus = function () {
        return this.get("CENS" /* Census */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventProbate = function () {
        return this.get("PROB" /* Probate */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventWill = function () {
        return this.get("WILL" /* Will */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventGraduation = function () {
        return this.get("GRAD" /* Graduation */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventRetirement = function () {
        return this.get("RETI" /* Retirement */, null, SelectionIndividualEvent);
    };
    SelectionIndividualRecord.prototype.getEventOther = function () {
        return this.get("EVEN" /* Event */, null, SelectionIndividualEvent);
    };
    /* End events */
    /* Attributes */
    SelectionIndividualRecord.prototype.getAttributeCaste = function () {
        return this.get("CAST" /* Caste */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributePhysicalDescription = function () {
        return this.get("DSCR" /* PhysicalDescription */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeScholasticAchievement = function () {
        return this.get("EDUC" /* Education */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeIdentificationNumber = function () {
        return this.get("IDNO" /* IdentificationNumber */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeNationality = function () {
        return this.get("NATI" /* Nationality */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeChildrenCount = function () {
        return this.get("NCHI" /* ChildrenCount */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeRelationshipCount = function () {
        return this.get("NMR" /* MarriageCount */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeOccupation = function () {
        return this.get("OCCU" /* Occupation */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributePossessions = function () {
        return this.get("PROP" /* Property */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeReligiousAffiliation = function () {
        return this.get("RELI" /* Religion */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeResidence = function () {
        return this.get("RESI" /* Residence */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeNobilityTitle = function () {
        return this.get("TITL" /* Title */, null, SelectionIndividualAttribute);
    };
    SelectionIndividualRecord.prototype.getAttributeFact = function () {
        return this.get("FACT" /* Fact */, null, SelectionIndividualAttribute);
    };
    /* End attributes */
    SelectionIndividualRecord.prototype.getChildFamilyLink = function () {
        return this.get("FAMC" /* FamilyChild */, null, SelectionChildFamilyLink);
    };
    SelectionIndividualRecord.prototype.getSpouseFamilyLink = function () {
        return this.get("FAMS" /* FamilySpouse */, null, SelectionSpouseFamilyLink);
    };
    SelectionIndividualRecord.prototype.getAssociation = function () {
        return this.get("ASSO" /* Associates */, null, SelectionAssociation);
    };
    return SelectionIndividualRecord;
}(SelectionWithMultimediaMixin(SelectionWithNoteSourceCitationMixin(SelectionRecord))));
export { SelectionIndividualRecord };
//# sourceMappingURL=SelectionIndividualRecord.js.map